export default __webpack_public_path__ + "static/media/shareTw2.e17d4cac.png";